import { Component, inject } from '@angular/core';
import { NgClass } from '@angular/common';
import { ReloadBonusesService } from '../../../../../../core/services/reload-bonuses.service';
import { TranslatePipe } from '../../../../../../core/shared/translation/translate.pipe';

@Component({
  selector: 'app-deposit-reload-bonuses',
  imports: [
    TranslatePipe,
    NgClass,
  ],
  templateUrl: './deposit-reload-bonuses.component.html',
  styleUrl: './deposit-reload-bonuses.component.scss',
})
export class DepositReloadBonusesComponent {

  protected reloadBonuses = inject(ReloadBonusesService);

}
